import React from 'react';

const UbisoftLogoGradient = () => {
  return (
    <svg
      version='1.1'
      id='Ubisoft_Mark'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 808.6 841.9'
      enableBackground='new 0 0 808.6 841.9'
    >
      <linearGradient
        id='SWIRL_1_'
        gradientUnits='userSpaceOnUse'
        x1='403.1611'
        y1='826.6958'
        x2='403.1611'
        y2='13.0894'
      >
        <stop offset='0' style={{ stopColor: '#ebeef4' }} />
        <stop offset='1' style={{ stopColor: '#ceecf0' }} />
      </linearGradient>
      <path
        id='SWIRL'
        className='st0'
        style={{ fill: 'url(#SWIRL_1_)' }}
        d='M795,419.4C786.4,2.7,232-152.6,18.6,237.9c9.4,6.8,22.5,16,31.9,22.8C34.2,295,23.3,330,17.3,364.8
	c-4.1,22.8-6.3,46.3-6.3,70.3c0,216.3,175.6,391.6,392.2,391.6s392.2-175.3,392.2-391.6C795.3,429.9,795.2,424.7,795,419.4z
	 M107.8,489.4c-5.2,42.4-1.9,55.7-2,60.7l-9.4,3.4c-3.6-7-12.6-31.6-16.6-64.6C69.6,362.8,155.6,249.2,286.6,228
	c120.1-17.6,235,56.9,261.9,161.2l-9.5,3.4c-2.8-3.1-7.8-11.5-26-29.9C368.2,217.4,140.5,284,107.8,489.4z M481,559.9
	c-19.3,27.8-51.5,45.9-87.9,45.9c-59.1,0-107-47.8-107-106.8c0-56.4,43.8-102.5,99.2-106.5l0,0c34.5-1.4,66.7,17.2,82,47.5
	c16.5,32.6,10.5,72.7-15.3,99.8C461.7,546.5,471.3,553.2,481,559.9z M704,564c-56.6,128.2-173,195.3-297.4,193.8
	C168.1,746,98.7,471,258.1,371.7l7,7c-2.7,3.6-12,11.1-26.9,40.2c-17.4,35.4-22.7,70.7-20.6,92.7c12.4,192.3,281.8,231.4,374.6,41.3
	c118.1-260.7-195-525.5-472.9-323.1l-6.4-6.4C186,108.8,328.9,57.5,465.3,91.8C674,143.9,786,361.2,704,564z'
      />
    </svg>
  );
};

export default UbisoftLogoGradient;
